import React from 'react' 
import Slider from "react-slick";

export default function Woware() {
    let settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 3,  
  
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1
          }
        }]
      }; 

  return (
    <>
      <section className="hero position-relative p70 pb-md-3">
    <div className="container">
      <h2 className="hadding ttu text-center"> 
        who <span className="color1">we are</span>
      </h2>
      <p className="max_p text-center">
      Blockchain Investment Expo Korea, is hosted by the World Blockchain Federation (WBF). Build networks and discover new business possibilities through the world's largest blockchain expo with top investors and blockchain industry leaders. Don't miss the opportunity to form a network of top blockchain companies and new users for development, data technology, machinery, transactions, and investments. Learn about the blockchain industry, mining industry, blockchain, and investment. We are very good at organizing B2C events by providing the blockchain industry with the highest quality educational resources and networking potential. (Hansblock, Technoloader, UN-Special Coherent Organization, Jeju Tourism Organization, Korea Virtual Asset User Association, Blockchain Enterprise Promotion Association, DBIexchange, UAE Tokenbank, Blockchain Information Certification Institute, and New York World NFT Metaverse Association will join together.

      </p>


      <Slider className='man_c' {...settings}> 
      <div className="box1">
            <div className="overview_h">
              <img src="img/expo.jpg" alt="expo" className="w100" />
            </div>
            <div className="box11">
              <h3>Expo</h3>
              <p>
              Representing thousands of traders and investors, the leading blockchain brand brings the best digital industry products and services to the forefront.

              </p>
            </div>
          </div>
          <div className="box1">
            <div className="overview_h">
              <img src="img/conference.jpg" alt="Conference" className="w100" />
            </div>
            <div className="box11">
              <h3>Conference</h3>
              <p>
              The industry's leading experts provide traders, investors and companies with valuable insights and latest updates on payment technology, trading technology and cryptocurrencies to enrich their understanding and knowledge.

              </p>
            </div>
          </div>
          <div className="box1">
            <div className="overview_h">
              <img src="img/awards.jpg" alt="Awards" className="w100" />
            </div>
            <div className="box11">
              <h3>Awards</h3>
              <p>
              We combine the best gift and investment opportunities for outstanding companies honored at awards ceremonies. Submit a brief overview of your company.

              </p>
            </div>
          </div>
          <div className="box1">
            <div className="overview_h">
              <img src="img/location.jpg" alt="Awards" className="w100" />
            </div>
            <div className="box11">
              <h3>Location</h3>
              <p>
              We combine the best gift and investment opportunities for outstanding companies honored at awards ceremonies. Submit a brief overview of your company.

              </p>
            </div>
          </div>
      </Slider>



 
    </div>
  </section>
    </>
  )
}
